import { Button, Col, Drawer, Row, Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onSubmit: () => void;
  onClose: () => void;
} & (
  | {
      type: 'publish' | 'unpublish';
      open: true;
    }
  | {
      type: undefined;
      open: false;
    }
);

export const BulkPublishDrawer: FC<Props> = ({
  type,
  open,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <Drawer open={open} onClose={onClose}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          {type === 'publish' ? (
            <Text text={t('bulk-publish-confirm-message')} />
          ) : (
            <Text text={t('bulk-unpublish-confirm-message')} />
          )}
        </Col>
        <Col span={24}>
          <Button onClick={onSubmit}>{t('execute')}</Button>
        </Col>
      </Row>
    </Drawer>
  );
};
